import React from "react";

import { useLoadableSlice } from "../../store/shared";
import {
  fetchDiscovered,
  getDiscoveredDevices,
} from "../../store/devices/discovered";
import {
  fetchRequestsWithName,
  getRequestsWithName,
} from "../../store/devices/requestsWithName";
import { getDisplayName } from "../../utils/getDisplayName";
import { fetchLines, getLines } from "../../store/devices/lines";
import {
  fetchLogicalDevices,
  getLogicalDevices,
} from "../../store/devices/logicalDevices";

export function withSettingDevicesGuard(Component) {
  function SettingDevicesGuard(props) {
    const logicalSlice = useLoadableSlice(
      fetchLogicalDevices(),
      getLogicalDevices
    );
    const linesSlice = useLoadableSlice(fetchLines(), getLines);
    const discoveredSlice = useLoadableSlice(
      fetchDiscovered(true),
      getDiscoveredDevices
    );
    const withNameSlice = useLoadableSlice(
      fetchRequestsWithName(true),
      getRequestsWithName
    );

    if (
      [logicalSlice, linesSlice, discoveredSlice, withNameSlice].includes(null)
    ) {
      return null;
    }

    return <Component {...props} />;
  }

  SettingDevicesGuard.displayName = `withSettingDevicesGuard(${getDisplayName(
    Component
  )})`;
  return SettingDevicesGuard;
}
